import { combineUrl } from '@agilepoint/utils-common';
import React from 'react';
import { IAutenticateUserResponseProps } from '../types';
import { setCookie } from '../../../common';
import { COOKIE_NAME } from 'index';

interface ISetWindowObjConfigProps {
    endPointURL: string;
    basePath: string;
    baseURL: string;
    // userType: string;
    cookieExpirationValue?: number;
}

const configFilePath = combineUrl(process.env.PUBLIC_URL || '/', `config.json?${new Date()}`);

function getConfig() {
    return fetch(configFilePath).then((r) => r.json());
}

async function getAuthInfo() {
    const config = await getConfig();
    const { auth, expires } = config?.agilepoint || {};
    return { auth, expires };
}

export const DEFAULT_COOKIE_EXPIRATION_VALUE = 14;

export function useSetWindowObjConfig(props: ISetWindowObjConfigProps) {
    const { endPointURL, basePath, baseURL, cookieExpirationValue } = props;
    const cookieExpirationDays = cookieExpirationValue ? cookieExpirationValue : DEFAULT_COOKIE_EXPIRATION_VALUE;

    const setUserDetails = React.useCallback((userDetails: IAutenticateUserResponseProps,
        authorization: string, keepMeSignedIn: boolean) => {
        const { username, fullName, userType } = userDetails;
        setCookie(COOKIE_NAME, JSON.stringify({
            basePath: basePath,
            baseUrl: baseURL,
            authentication: {
                getToken: getAuthInfo,
                renewToken: getAuthInfo
            },
            agilepoint: {
                apiUrl: endPointURL,
                culture: 'en-US',
                domain: 'nxone',
                userName: username,
                staySignedIn: true,
                auth: authorization,
                userDetails: {
                    userName: username,
                    fullName: fullName
                },
                cookieExpirationDays,
                userType
            }
        }), cookieExpirationDays, keepMeSignedIn);
    }, [basePath, baseURL, endPointURL, cookieExpirationDays]);

    return {
        setUserDetails
    };
}
